import { render, staticRenderFns } from "./MemoSync.vue?vue&type=template&id=006b5f58&scoped=true&"
import script from "./MemoSync.vue?vue&type=script&lang=js&"
export * from "./MemoSync.vue?vue&type=script&lang=js&"
import style0 from "./MemoSync.vue?vue&type=style&index=0&id=006b5f58&scoped=true&lang=css&"
import style1 from "@/assets/wap/cloud-mobile.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b5f58",
  null
  
)

export default component.exports